import { render, staticRenderFns } from "./b2b-bell-menu.vue?vue&type=template&id=5cc71322&scoped=true"
import script from "./b2b-bell-menu.vue?vue&type=script&lang=js"
export * from "./b2b-bell-menu.vue?vue&type=script&lang=js"
import style0 from "./b2b-bell-menu.vue?vue&type=style&index=0&id=5cc71322&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc71322",
  null
  
)

export default component.exports